var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-clone":true,"disable-edit":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }